var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPaperclip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.688 20.3a5.825 5.825 0 0 1 0-8.201l8.729-8.791a4.425 4.425 0 0 1 6.281 0 4.493 4.493 0 0 1 0 6.326l-7.35 7.402a3.113 3.113 0 0 1-4.42 0 3.161 3.161 0 0 1 0-4.451l6.225-6.269a.463.463 0 0 1 .659 0l.658.663a.471.471 0 0 1 0 .663L9.245 13.91a1.278 1.278 0 0 0 0 1.799 1.258 1.258 0 0 0 1.787 0l7.35-7.402a2.61 2.61 0 0 0 0-3.674 2.57 2.57 0 0 0-3.649 0l-8.729 8.79a3.941 3.941 0 0 0 0 5.55 3.877 3.877 0 0 0 5.515-.001l7.6-7.657a.463.463 0 0 1 .658 0l.658.663a.47.47 0 0 1 0 .663l-7.599 7.656a5.729 5.729 0 0 1-8.148.001z",
    fill: "#8F9BB3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaperclip);
export default __webpack_public_path__ + "static/media/icon-paperclip.a2391b45.svg";
export { ForwardRef as ReactComponent };